export let CLOSE_ERROR_DIALOG = 'CLOSE_ERROR_DIALOG';
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'
export const SET_ERROR_DIALOG = 'SET_ERROR_DIALOG'
